var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable, action, computed, observe } from "mobx";
import { eBranches } from "sb-helpers";
import { SiteDirection, SelectionType, ItemState, GameStatus } from "../../../data";
import { DataParser } from "../../../parser";
// TODO
// slider step = card width + margin
const defaultStep = 304;
export class SuperBannerData {
    constructor(provider, oddsFormatHelper, clientIncludeInManager) {
        this.provider = provider;
        this.oddsFormatter = oddsFormatHelper;
        this.items = [];
        this.disposeList = [];
        this.clientIncludeInManager = clientIncludeInManager;
        this.items = this.provider.items;
        //this.reinitObserves();
        this.calcs = {
            step: defaultStep,
            container: 0,
            wrapper: 0,
            multiplier: 1
        };
        this.pages = [];
        this.currentPage = 0;
        this.itemWidth = undefined;
        this.deviceDetect = provider.dataFacade.deviceDetectHelper.deviceDetect;
        this.statusesToDisplay = [ItemState.available, ItemState.loading];
        this.currentSelectedSportId = provider.currentSelectedSportId;
        this.disposeItemsChange = observe(this.provider, (change) => {
            let changedObject = change.object;
            this.updateCollection(changedObject);
        });
        this.disposeCurrentSelectedSportIdChange = observe(this.provider, "currentSelectedSportId", (change) => {
            this.updateCurrentSelectedSportId(change.newValue);
        });
    }
    get siteDirection() {
        if (document.documentElement) {
            /* istanbul ignore next */
            return document.documentElement.getAttribute("dir") === "rtl"
                ? SiteDirection.rightToLeft
                : SiteDirection.leftToRight;
        }
        return SiteDirection.leftToRight;
    }
    updateCollection(change) {
        this.items = change.items;
    }
    updateCurrentSelectedSportId(sportId) {
        this.currentSelectedSportId = sportId;
    }
    get itemsToDisplay() {
        return this.items.filter(item => this.validateStatus(item) &&
            !(this.provider.dataFacade.cms.DisplayMobileMode && !item.PickedEvent)
            && this.isItemForCurrentSport(item)
            && this.isNotLiveRacingEvent(item));
    }
    updateClientIncludeData() {
        this.items.forEach(item => item.ClientHashClass = this.clientIncludeInManager.getElementClass(item.ClientHashAttribute));
    }
    validateStatus(item) {
        return this.statusesToDisplay.indexOf(item.state) !== -1 &&
            (!item.PickedEvent || this.statusesToDisplay.indexOf(item.PickedEvent.state) !== -1);
    }
    isItemForCurrentSport(item) {
        return (this.currentSelectedSportId === item.SportId || item.SportId === 0);
    }
    isNotLiveRacingEvent(item) {
        if (item.PickedEvent
            && item.PickedEvent.event
            && this.isRacingEvent(item.PickedEvent.event.sportID)
            && this.isLiveOrFinished(item.PickedEvent.event.status)) {
            return false;
        }
        return true;
    }
    isRacingEvent(sportId) {
        return sportId === eBranches.HorseRacing.toString()
            || sportId === eBranches.GreyHoundsRacing.toString();
    }
    isLiveOrFinished(status) {
        return status === GameStatus.RaceOff
            || status === GameStatus.Resulted;
    }
    // TODO Cover with tests
    /* istanbul ignore next */
    setupCalcs(wrapper, container, displayMultipleItems) {
        if (wrapper && container) {
            let items = container.getElementsByClassName("rj-superbanner__item");
            this.calcs.wrapper = wrapper.offsetWidth;
            !displayMultipleItems && this.setItemWidth(this.calcs.wrapper);
            this.calcs.container = container.offsetWidth;
            if (items.length) {
                let i = items[0]["offsetWidth"];
                let dI = i * items.length;
                let dC = (this.calcs.container - dI) / (items.length - 1);
                this.calcs.step = i + dC;
            }
        }
    }
    /* istanbul ignore next */
    updatePagination() {
        let counter = this.getPagesCount(this.calcs);
        this.pages.length = counter;
        for (let i = 0; i < counter; i += 1) {
            this.pages[i] = {
                id: i,
                isCurrent: this.currentPage === i
            };
        }
    }
    /* istanbul ignore next */
    updateCurrentPage(index) {
        this.pages = this.pages.map((page, i) => (Object.assign(Object.assign({}, page), { isCurrent: index === i })));
        this.currentPage = index;
        this.setSlideMultiplier(1);
    }
    /* istanbul ignore next */
    setCurrentPage(inc) {
        this.currentPage = Math.max(Math.min(this.currentPage + inc, this.pages.length - 1), 0);
    }
    /* istanbul ignore next */
    setSlideMultiplier(val) {
        this.calcs.multiplier = val;
    }
    /* istanbul ignore next */
    getInvisibleSpace(calcs) {
        let invisibleSpace = 0;
        if (calcs && calcs.wrapper && calcs.container) {
            invisibleSpace = calcs.container - calcs.wrapper;
        }
        return Math.max(invisibleSpace, 0);
    }
    /* istanbul ignore next */
    getPagesCount(calcs) {
        let counter = 0;
        if (calcs && calcs.step) {
            counter = Math.ceil(this.getInvisibleSpace(calcs) / calcs.step) + 1;
        }
        return counter;
    }
    /* istanbul ignore next */
    getProgressPageIndex(calcs, progress) {
        return Math.max(Math.min(Math.round(-progress / calcs.step), this.getPagesCount(calcs) - 1), 0);
    }
    /* istanbul ignore next */
    addToSlipTranspiler(selection, eventId, marketId) {
        this.provider.addToSlipTranspiler(selection, eventId, marketId);
    }
    /* istanbul ignore next */
    getImageHeight(item, cms) {
        const event = item.PickedEvent;
        if (!cms.DisplayMultipleItems && this.provider.dataFacade.deviceDetectHelper.deviceDetect.isDesktop) {
            return "220px";
        }
        if (event) {
            if (this.hasResolvedQAMarket(event) || this.hasPickedCMSMarketAndNotResolvedYetMarket(event)) {
                return "0px";
            }
            return "80px";
        }
        return "190px";
    }
    /* istanbul ignore next */
    hasPickedCMSMarketAndNotResolvedYetMarket(event) {
        /* istanbul ignore next */
        return !event.market && event.IsOutright || event.IsQA;
    }
    /* istanbul ignore next */
    hasResolvedQAMarket(event) {
        /* istanbul ignore next */
        return !!event.market && event.market.type === SelectionType.QA;
    }
    /* istanbul ignore next */
    getSuperBannerItemModifier(item) {
        if (item.PickedEvent
            && item.PickedEvent.market
            && item.PickedEvent.market.type === SelectionType.QA) {
            return this.oddsFormatter.Outright.getOddsOrderClass(item.PickedEvent.market.selections);
        }
        return "";
    }
    /* istanbul ignore next */
    showFreeHtml(item) {
        if (item.PickedEvent && item.PickedEvent.market && item.PickedEvent.market.type === SelectionType.QA) {
            return false;
        }
        return true;
    }
    /* istanbul ignore next */
    getBetBtnModifier(selection, type) {
        const betBtnModifier = `rj-superbanner__bet-button UniqueOdd_${selection.sbtechId}_${type === SelectionType.QA ? 1 : 0}`;
        if (selection.isSelected) {
            return `${betBtnModifier} rj-superbanner__bet-button--selected chosenBet`;
        }
        return betBtnModifier;
    }
    setItemWidth(w) {
        this.itemWidth = w;
    }
    eventHasStarted(ev) {
        return ev.isLive && ev.liveStartCountdown <= 0;
    }
    eventHasLiveScb(ev) {
        return !!ev.scoreboard && ev.isLive;
    }
}
__decorate([
    observable,
    __metadata("design:type", Number)
], SuperBannerData.prototype, "currentSelectedSportId", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], SuperBannerData.prototype, "items", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], SuperBannerData.prototype, "pages", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SuperBannerData.prototype, "itemWidth", void 0);
__decorate([
    observable,
    __metadata("design:type", DataParser)
], SuperBannerData.prototype, "provider", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [DataParser]),
    __metadata("design:returntype", void 0)
], SuperBannerData.prototype, "updateCollection", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], SuperBannerData.prototype, "updateCurrentSelectedSportId", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], SuperBannerData.prototype, "itemsToDisplay", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SuperBannerData.prototype, "updateClientIncludeData", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SuperBannerData.prototype, "updatePagination", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], SuperBannerData.prototype, "updateCurrentPage", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], SuperBannerData.prototype, "setItemWidth", null);
//# sourceMappingURL=SuperBannerData.js.map